'use client'
import { Box } from '@mui/material'
import { useBlockNumber } from '@/state/application/hooks'
import Audio from './Audio'
export const BlockNumberComponent = () => {
  const blockNumber = useBlockNumber()

  return (
    <Box>
      {blockNumber
        ? (
          <div className='flex items-center'>
            <Audio />
            <p className='text-end text-xs font-fira  text-mint'>{blockNumber}</p>
          </div>
          )
        : <></>}
    </Box>
  )
}
